import loginModel from './login/model';

export default {
    ...loginModel,
};